import { base64ToByteBuffer } from "./base64";
const calcRRMarks = (Qs, fd, top_mm = 5) => {
    // Проверка если типизированный массив поступил на вход
    if (!Array.isArray(Qs)) {
        Qs = [...Qs];
    }
    const RRs = Qs.map((q, i, q_arr) => {
        const RR = q - q_arr[i - 1];
        const ans = {
            RR,
            pos: q - RR / 2
        };
        return ans;
    }).slice(1);
    const marks = {
        texts: RRs.map(rr => "" + Math.round((rr.RR * 1000) / fd)),
        Xs_pnt: RRs.map(rr => rr.pos),
        Ys_mm: new Array(RRs.length).fill(top_mm)
    };
    return {
        RRs,
        marks
    };
};

const parseSignal_LeadsIn1String = (_signalString, _lsb = 1) => {
    const data = [];
    const chdata = new Int32Array(base64ToByteBuffer(_signalString));
    const ptsQty = chdata.length;
    for (let i = 0; i < ptsQty; i++) {
        data[i] = chdata[i] / _lsb;
    }
    return data;
};
const parseSignal_LeadsInSeparateStrings = (_signalStrings, _lsb = 1) => {
    const data = [];

    const ptsInChannels = _signalStrings.map(_s => new Int32Array(base64ToByteBuffer(_s)));
    const chQty = ptsInChannels.length;
    const ptsQty = ptsInChannels[0].length;
    for (let i = 0; i < chQty; i++) {
        for (let j = 0; j < ptsQty; j++) {
            data[i + chQty * j] = ptsInChannels[i][j] / _lsb;
        }
    }
    return data;
};
const parseSignal_LeadsInSeparateArrays = (_signalStrings, _lsb = 1) => {
    const data = [];

    const ptsInChannels = _signalStrings;
    const chQty = ptsInChannels.length;
    const ptsQty = ptsInChannels[0].length;
    for (let i = 0; i < chQty; i++) {
        for (let j = 0; j < ptsQty; j++) {
            data[i + chQty * j] = ptsInChannels[i][j] / _lsb;
        }
    }
    return data;
};
export { calcRRMarks, parseSignal_LeadsIn1String, parseSignal_LeadsInSeparateStrings, parseSignal_LeadsInSeparateArrays };
